module.exports = __webpack_public_path__ + "static/media/handshake-fill.7a77a257.svg";